import { render, staticRenderFns } from "./integrated.vue?vue&type=template&id=21306468&scoped=true&"
import script from "./integrated.vue?vue&type=script&lang=js&"
export * from "./integrated.vue?vue&type=script&lang=js&"
import style0 from "./integrated.vue?vue&type=style&index=0&id=21306468&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21306468",
  null
  
)

export default component.exports